import React, { useEffect, useState } from "react";
import Admin from "..";
import { useLocation, useNavigate } from "react-router-dom";
import functions from "../../../utils/Api";
import { useDispatch, useSelector } from "react-redux";
import DiscardChangesDialog from "../../../components/DiscardChangesDialog/DiscardChangesDialog";
import { Box, CircularProgress } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import Toaster from "../../../components/Toaster/Toaster";
import { editUserValidations } from "../../../Validations/Validations";
import { dispatchRefreshApiCallUser } from "../../../Redux/dispatcher";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs";
import {
  setToasterStatusMsg,
  setUserPermissions,
} from "../../../Redux/reportSlice";
import { use } from "react";

const EditUser = ({ loginDetails }) => {
  let location = useLocation();
  let navigate = useNavigate();
  let dispatcher = useDispatch();
  let id = location.pathname.split("/")[3];
  const [userDataByid, setUserDataByid] = useState(null);
  const [userDetailsChanges, setUserDetailsChanges] = useState(false);
  const [updateUserStatus, setUpdateUserStatus] = useState([]);
  const [disableCreateBtn, setDisableCreateBtn] = useState(false);
  const [userDetails, setUserDetails] = useState({
    // userType: "",
    location: null,
    officeLocationId: null,
    firstName: "",
    lastName: "",
    empId: null,
    email: "",
    // password: "",
    contactNumber: null,
    designation: "",
    permission: [],
    roleId: null,
    isActive: false,
    employeeId: "",
  });

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
  ];

  useEffect(() => {
    if (id) {
      try {
        functions
          .get(`/employee/${id}`)
          .then((res) => {
            let details = {
              officeLocationId: res?.data ? res?.data?.officeLocationId : null,
              firstName: res?.data ? res?.data?.firstName : "",
              lastName: res?.data ? res?.data.lastName : "",
              empId: res.data ? res?.data.empId : null,
              email: res?.data ? res?.data?.email : "",
              employeeId: res.data ? res?.data.employeeId : "",
              // password: res?.data ? res.data.password : "",
              contactNumber: res?.data ? res.data.contactNumber : null,
              designation: res?.data ? res?.data.designation : "",
              permission: res?.data
                ? res?.data?.permission.map((item) => {
                    return {
                      permissionId: item.permissionId,
                      permissionName: item.permissionName,
                    };
                  })
                : null,
              roleId: res.data ? res?.data.roleId : null,
              isActive: res?.data ? res.data?.isActive : false,
            };
            setUserDetails(details);
            setUserDataByid(details);
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    }
  }, [id]);

  const areObjectsEqual = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if the number of keys is different
    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      const val1 = obj1[key];
      const val2 = obj2[key];

      // Handle arrays and objects recursively
      const areBothObjects =
        typeof val1 === "object" && typeof val2 === "object";

      if (areBothObjects && val1 !== null && val2 !== null) {
        if (!areObjectsEqual(val1, val2)) {
          return false;
        }
      } else if (val1 !== val2) {
        return false;
      }
    }
    return true; // All keys and values match
  };

  const handleRedirect = () => {
    if (userDataByid !== null) {
      const isEqual = areObjectsEqual(userDataByid, userDetails);
      if (!isEqual) {
        setUserDetailsChanges(true); // Changes detected
      } else {
        setUserDetailsChanges(false); // No changes detected
        navigate("/cms/users-list");
      }
    }
  };

  const handleCreate = () => {
    setUserDetailsChanges(false);
    navigate("/cms/users-list");
  };

  const handleSubmitUser = (data) => {
    setDisableCreateBtn(true);
    if (id) {
      try {
        functions
          .put(`/employee/${id}`, userDetails)
          .then((res) => {
            if (res) {
              setUpdateUserStatus(res);
              dispatcher(dispatchRefreshApiCallUser(true));
              dispatcher(
                setToasterStatusMsg({
                  msg: "User Updated successfully",
                  severity: "success",
                })
              );
              navigate("/cms/users-list");
            }
          })
          .catch((err) => {
            dispatcher(
              setToasterStatusMsg({
                msg: err.message || "Something went wrong",
                severity: "success",
              })
            );
            setUpdateUserStatus([]);
          });
      } catch (error) {
        setUpdateUserStatus([]);
      }
    }
  };

  return (
    <div>
      <Box className="Admin-breadCrumb">
        <CustomBreadcrumbs items={breadCrumbData} currentLabel="Users" />
      </Box>
      {userDataByid ? (
        <Admin
          title="Update"
          userDetails={userDetails}
          setUserDetails={setUserDetails}
          handleSubmitUser={handleSubmitUser}
          handleRedirect={handleRedirect}
          // userFormValidations={editUserValidations(userDetails.roleId)}
          disableBtn={disableCreateBtn}
          loginDetails={loginDetails}
        />
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      )}
      {userDetailsChanges && (
        <DiscardChangesDialog
          title="Unsaved Changes"
          text=" If you go back now, any information you've entered will be lost.
            Are you sure you want to leave without saving?"
          createBtn=" Yes, Go Back"
          open={userDetailsChanges}
          handleClose={setUserDetailsChanges}
          handleCreate={handleCreate}
        />
      )}
    </div>
  );
};

export default EditUser;
